// let proUpsells = document.querySelectorAll("[data-product-upsell-a2c]");
// proUpsells.forEach(btn => {
//   btn.addEventListener("click",function(e){
//     e.preventDefault();
//     console.log("clicked",this, this.dataset.variant);
//     let pro = {};
//     pro.id = this.dataset.variant;
//     pro.quantity = 1;
//     // pro.properties = {};
//     // pro.properties["productAs"] = "upsell";
//     // console.log("pro",pro);
//     upsellProducts(pro);
//   });
// });

let proUpsellProVariants =  document.querySelectorAll("[data-pro-upsell-variant]");
proUpsellProVariants.forEach(item => {
  item.addEventListener("change",function(e){
    e.preventDefault();
    // console.log("this.dataset.price",this.dataset.price);
    // console.log("this.dataset.priceMoney",this.dataset.priceMoney,this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-price]").innerText);
    this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").value = this.value;
    this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").dataset.price = this.dataset.price;
    this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-price]").innerText = this.dataset.priceMoney;
    this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-img]").setAttribute("src",this.dataset.image);
    if(this.dataset.price == 0){
      this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").checked = false;
      let event = new Event('change');
      this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").dispatchEvent(event);
    }else{
      // if(this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").checked == false){
        this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").checked = true;
        let event = new Event('change');
        this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").dispatchEvent(event);
      // }
    }
    if(this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").hasAttribute("disabled")){
      this.closest("[data-pro-upsell-item]").querySelector("[data-pro-upsell-checkbox]").removeAttribute("disabled");
    }
  });
});

let proUpsellCheckboxes =  document.querySelectorAll("[data-pro-upsell-checkbox]");
proUpsellCheckboxes.forEach(checkbox => {
  checkbox.addEventListener("change",function(e){
    e.preventDefault();
    manageUpsellProPrices();
  });
});

function manageUpsellProPrices(){
  let proUpsellCheckboxes_checked = document.querySelectorAll("[data-pro-upsell-checkbox]:checked:not([disabled])");
  let bundlePrice = 0;
  proUpsellCheckboxes_checked.forEach(selCheckbox => {
    // console.log("selCheckbox.dataset.price",selCheckbox.dataset.price);
    bundlePrice += Number(selCheckbox.dataset.price);
  });
  let proPriceEle = document.querySelector("[data-product-price]");
  bundlePrice += Number(proPriceEle.dataset.price);
  // console.log("bundlePrice",theme.Currency.formatMoney(bundlePrice, "${{amount}}"));
  proPriceEle.innerHTML = theme.Currency.formatMoney(bundlePrice, "${{amount}}");
  if(proUpsellCheckboxes_checked.length){
    document.querySelector(".page-content--product").classList.add("upsell-selected");
  }else{
    document.querySelector(".page-content--product").classList.remove("upsell-selected");
  }
}
manageUpsellProPrices();

// function upsellProducts(proObj) {
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { "Accept": "application/json", "Content-Type": "application/json" },
//     body: JSON.stringify(proObj)
//   })
//   .then(response => response.json()).then(response => {
//     // console.log("response",response);
//     setTimeout(() => {
//       document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
//     },500);
    
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   })
//   .finally((e) => {
//     // console.log("finally");
//   });
// }